import { Component, OnInit } from '@angular/core';
import { Log } from 'ng2-logger';
import { AdminService } from '../../_services/admin.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr';
import { ACLFeature } from '../../_models/acl-feature';

import 'rxjs/add/operator/mergeMap';

const log = Log.create('BatchEditModules');

@Component({
  templateUrl: 'edit.component.html',
  styleUrls: ['edit.less']
})

export class BatchEditModulesComponent implements OnInit {

  parentId: number;
  path: string;
  familiyIds: any;
  families: any;

  isVisible?: boolean = false;
  isVisibleNa?: boolean = false;
  isVisibleSa?: boolean = false;
  isVisibleCn?: boolean = false;
  isVisibleRoa?: boolean = false;

  isInMaintenanceMode?: boolean = false;
  isInMaintenanceModeNa?: boolean = false;
  isInMaintenanceModeSa?: boolean = false;
  isInMaintenanceModeCn?: boolean = false;
  isInMaintenanceModeRoa?: boolean = false;

  viewStatus?: any;
  viewStatusNa?: any;
  viewStatusSa?: any;
  viewStatusCn?: any;
  viewStatusRoa?: any;

  iCanArchive: boolean = true;
  iCanViewArchive: boolean = true;

  sortOrder?: number = null;

  image?: string = null;

  solutionComment?: string = null;

  possibleCapabilities: any;
  capabilities: Array<any> = [];
  possibleModuleFamilies: any;
  possibleModuleFamilyNames: any;
  family?: any = null;
  familyNa?: any = null;
  familySa?: any = null;
  familyCn?: any = null;
  familyRoa?: any = null;

  datasheetUrl?: string = ''; // Database does not allow null for datasheetUrls
  datasheetUrlNa?: string = '';
  datasheetUrlSa?: string = '';
  datasheetUrlCn?: string = '';
  datasheetUrlRoa?: string = '';

  phaseIn?: string = null;
  phaseOut?: string = null;
  phaseInNa?: string = null;
  phaseOutNa?: string = null;
  phaseInSa?: string = null;
  phaseOutSa?: string = null;
  phaseInCn?: string = null;
  phaseOutCn?: string = null;
  phaseInRoa?: string = null;
  phaseOutRoa?: string = null;

  height: any = 0;
  width: any = 0;
  length: any = 0;
  heightInch: any = 0;
  lengthInch: any = 0;
  widthInch: any = 0;
  dia: any = 0;
  boxQuantity: any = 0;

  possibleVoltageTypes: any;
  voltageTypes: Array<any> = [];

  toggleVisibility: boolean = false;
  toggleSortOrder: boolean = false;
  toggleMaintenanceMode: boolean = false;
  toggleImages: boolean = false;
  toggleSolutionComment: boolean = false;
  toggleModuleFamily: boolean = false;
  toggleModuleFamilyNa: boolean = false;
  toggleModuleFamilySa: boolean = false;
  toggleModuleFamilyCn: boolean = false;
  toggleModuleFamilyRoa: boolean = false;
  toggleDataSheet: boolean = false;
  toggleDataSheetNa: boolean = false;
  toggleDataSheetSa: boolean = false;
  toggleDataSheetCn: boolean = false;
  toggleDataSheetRoa: boolean = false;
  togglePhaseInOut: boolean = false;
  togglePhaseInOutNa: boolean = false;
  togglePhaseInOutSa: boolean = false;
  togglePhaseInOutCn: boolean = false;
  togglePhaseInOutRoa: boolean = false;
  toggleHousing: boolean = false;

  iCanMaintenanceMode: boolean = false;
  toggleVoltageTypes: boolean = false;
  toggleCapabilitie: boolean = false;
  toggleBoxQuantity: boolean = false;

  toggleViewStatus: boolean = false;
  toggleViewStatusNa: boolean = false;
  toggleViewStatusSa: boolean = false;
  toggleViewStatusCn: boolean = false;
  toggleViewStatusRoa: boolean = false;

  loader: boolean = false;

  toggleTags: boolean = false;
  tagFamilies: Array<any> = [];
  activeTagFamily: any = null;
  possibleTags: Array<any> = [];
  tags: Array<any> = [];

  constructor(private admin: AdminService,
              private route: ActivatedRoute,
              private router: Router,
              private toast: ToastsManager) {}

  ngOnInit() {
    this.loader = true;
    log.d('ngOnInit');
    // this.path = (this.route.snapshot.parent.params['type'] === 'modules') ? '/drilldown/modules' : '/drilldown/drivers';
    //
    this.route.params.subscribe((params: any) => {
      log.d(`route /${this.route.snapshot.parent.params['type']}/${params['id']}`);
      this.parentId = +params['parentId'];
      this.familiyIds = params.list.split(',').map( param => parseInt(param) ); // moet een array met getallen worden.
      log.d('families recieved from params', this.familiyIds);

      this.admin.getModuleControllers(this.familiyIds).subscribe((data) => {
        log.d('getModuleControllers response', data);
        this.families = data.data;

        this.admin.getModuleVoltageTypes().subscribe((response) => {
          log.d('possibleVoltageTypes response:', response.data);
          this.possibleVoltageTypes = response.data;
        });

        this.admin.getModuleFamilies().subscribe((response) => {
          this.possibleModuleFamilyNames = response.data.map(family => {
            return {
              id: family.id,
              text: family.treeName
            };
          });
          this.possibleModuleFamilies = response.data;
          this.loader = false;
        });

        this.admin.getModuleCapabilities().subscribe((res) => {
            this.possibleCapabilities = res.data;
        });

        this.admin.getTagFamiliesController().subscribe((res) => {
          this.tagFamilies = res.map((item) => {
            return {id: item.id, text: item.name};
          });
          if (this.tagFamilies.length > 0) {
            this.selectedModuleTagFamily(this.tagFamilies[0]);
          }
        });
      });
    });
    this.admin.canI(ACLFeature.MAINTENANCE_MODE_ADMIN).subscribe((iCan: boolean) => {
      this.iCanMaintenanceMode = iCan;
    });

    this.admin.canI(ACLFeature.VIEW_ARCHIVE_IN_ADMIN).subscribe((iCan: boolean) => {
      this.iCanViewArchive = iCan;
    });

    this.admin.canI(ACLFeature.ARCHIVE).subscribe((iCan: boolean) => {
      this.iCanArchive = iCan;
    });
  }

  public selectedModuleTagFamily(tagFamily) {
    this.admin.getTagFamilyController(tagFamily.id).subscribe((res) => {
      this.activeTagFamily = { id: res.id, text: res.name };
      this.possibleTags = res.tags;
    });
  }

  public selectedModuleFamilyId(value)    { this.setModuleFamilyName(value, 'family'); }
  public selectedModuleFamilyNaId(value)  { this.setModuleFamilyName(value, 'familyNa'); }
  public selectedModuleFamilySaId(value)  { this.setModuleFamilyName(value, 'familySa'); }
  public selectedModuleFamilyCnId(value)  { this.setModuleFamilyName(value, 'familyCn'); }
  public selectedModuleFamilyRoaId(value) { this.setModuleFamilyName(value, 'familyRoa'); }

  public setModuleFamilyName(value, modelName) {
    const moduleFamilyIndex = this.possibleModuleFamilies.findIndex(family => family.id === value.id);
    this[modelName] = this.possibleModuleFamilies[moduleFamilyIndex];
  }

  public preselectedDropdownTagFamilyValue() {
    if (!this.tagFamilies.length) {
      return [];
    } else if (null != this.activeTagFamily) {
      return [this.activeTagFamily];
    } else {
      return [this.tagFamilies[0]];
    }
  }

  public preselectedDropdownValue(modelName) {
    if (!this[modelName]) {
      return [{
        text: 'None',
        id: 'None'
      }];
    }
    if (this[modelName].treeName) {
      return [{
        text: this[modelName].treeName,
        id: this[modelName].id
      }];
    }
    return [{
      text: this[modelName].name,
      id: this[modelName].id
    }];
  }

  private mmToInch($event) {
    // let mm = $event.target.value;
    this.heightInch = (this.height * 0.0393700787).toFixed(3);
    this.lengthInch = (this.length * 0.0393700787).toFixed(3);
    this.widthInch = (this.width * 0.0393700787).toFixed(3);
  }

  private inchToMm($event) {

    // let inch = $event.target.value;
    this.height = (this.heightInch * 25.4).toFixed(1);
    this.length = (this.lengthInch * 25.4).toFixed(1);
    this.width = (this.widthInch * 25.4).toFixed(1);
  }

  // used by checkbox and radio components
  private updateModel(input) {
    this[input.model] = input.updatedData;
  }

  public onSubmit() {
    this.loader = true;

    for (const family of this.families) {
      if (this.toggleViewStatus) {
        family.viewStatus = this.viewStatus;
      }
      if (this.toggleViewStatusNa) {
        family.viewStatusNa = this.viewStatusNa;
      }
      if (this.toggleViewStatusSa) {
        family.viewStatusSa = this.viewStatusSa;
      }
      if (this.toggleViewStatusCn) {
        family.viewStatusCn = this.viewStatusCn;
      }
      if (this.toggleViewStatusRoa) {
        family.viewStatusRoa = this.viewStatusRoa;
      }
      if (this.toggleSortOrder) {
        family.sortOrder = this.sortOrder;
      }
      if (this.toggleImages) {
        family.image = this.image;
      }
      if (this.toggleSolutionComment) {
        family.solutionComment = this.solutionComment;
      }
      if (this.toggleModuleFamily) {
        family.family = this.family;
      }
      if (this.toggleModuleFamilyNa) {
        family.familyNa = this.familyNa;
      }
      if (this.toggleModuleFamilySa) {
        family.familySa = this.familySa;
      }
      if (this.toggleModuleFamilyCn) {
        family.familyCn = this.familyCn;
      }
      if (this.toggleModuleFamilyRoa) {
        family.familyRoa = this.familyRoa;
      }
      if (this.toggleDataSheet) {
        family.datasheetUrl = this.datasheetUrl;
      }
      if (this.toggleDataSheetNa) {
        family.datasheetUrlNa = this.datasheetUrlNa;
      }
      if (this.toggleDataSheetCn) {
        family.datasheetUrlCn = this.datasheetUrlCn;
      }
      if (this.toggleDataSheetRoa) {
        family.datasheetUrlRoa = this.datasheetUrlRoa;
      }
      if (this.toggleDataSheetSa) {
        family.datasheetUrlSa = this.datasheetUrlSa;
      }
      if (this.togglePhaseInOut) {
        family.phaseIn = this.phaseIn;
        family.phaseOut = this.phaseOut;
      }
      if (this.togglePhaseInOutNa) {
        family.phaseInNa = this.phaseInNa;
        family.phaseOutNa = this.phaseOutNa;
      }
      if (this.togglePhaseInOutSa) {
        family.phaseInSa = this.phaseInSa;
        family.phaseOutSa = this.phaseOutSa;
      }
      if (this.togglePhaseInOutCn) {
        family.phaseInCn = this.phaseInCn;
        family.phaseOutCn = this.phaseOutCn;
      }
      if (this.togglePhaseInOutRoa) {
        family.phaseInRoa = this.phaseInRoa;
        family.phaseOutRoa = this.phaseOutRoa;
      }
      if (this.toggleHousing) {
        family.housing.height = this.height;
        family.housing.width = this.width;
        family.housing.length = this.length;
        family.housing.heightInch = this.heightInch;
        family.housing.widthInch = this.widthInch;
        family.housing.lengthInch = this.lengthInch;
        family.housing.dia = this.dia;
      }
      if (this.toggleVoltageTypes) {
        family.voltageTypes = this.voltageTypes;
      }

      if (this.toggleCapabilitie) {
          family.capabilities = this.capabilities;
      }

      if (this.toggleBoxQuantity) {
        family.boxQuantity = this.boxQuantity;
      }

      if (this.toggleTags) {
        family.tags = this.tags;
      }
    }

    log.d('updated modules', this.families);

    this.admin.postModuleControllers(this.families).subscribe(data => {
      this.loader = false;
      this.toast.success(`Changes have been saved.`);

      const firsthalf = window.location.href.split('parentId=');
      const secondhalf = firsthalf[1].split('/');
      const thirdhalf = secondhalf[0].split(';');
      const parentId = thirdhalf[0];

      const fourthhalf = thirdhalf[1].split('=');
      const archive = fourthhalf[1];

      this.router.navigate(['/drilldown/modules', {parentId: parentId, showArchived: archive, refresh: Date.now()}]);
    });
  }

  public onCancel() {
    log.d('onCancel');
    const firsthalf = window.location.href.split('parentId=');
    const secondhalf = firsthalf[1].split('/');
    const thirdhalf = secondhalf[0].split(';');
    const parentId = thirdhalf[0];

    const fourthhalf = thirdhalf[1].split('=');
    const archive = fourthhalf[1];

    this.router.navigate(['/drilldown/modules', {parentId: parentId, showArchived: archive, refresh: Date.now()}]);
  }
}



// WEBPACK FOOTER //
// ./src/app/batch/modules/edit.component.ts